module.exports = __webpack_public_path__ + "img/蒙版组 10@2x.be4901ad.webp";